export const LIMITED_COMPANY = 1
export const TRADING_COMPANY = 2
export const SOLE_PROPRIETORSHIP = 3
export const OTHER_COMPANY = 4
export const NOT_STARTED_COMPANY = 5
